import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useRecoilState } from 'recoil';
import { scrollState } from 'recoils/common/commonState';

import { throttleScroll } from 'utils/scroll/scrollUtil';

const useScrollTop = () => {
  const location = useLocation();
  const [scroll, setScroll] = useRecoilState(scrollState);

  /**
   * @function handleScroll
   * @desc 스크롤 동작 감지하여, 스크롤 동작 시 헤더 영역 box-shadow 생성
   */
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      // setScroll(currentScrollY > 60);
      setScroll(currentScrollY > 0); // 스크롤이 0보다 크면 true, 아니면 false
    };

    const throttledHandleScroll = throttleScroll(handleScroll, 100); // 100ms 간격으로 호출

    // 스크롤 이벤트 리스너 등록
    window.addEventListener('scroll', throttledHandleScroll);
    return () => {
      // 스크롤 이벤트 리스너 제거
      window.removeEventListener('scroll', throttledHandleScroll);
    };
  }, [setScroll]);

  /**
   * @function useEffect
   * @desc 페이지가 로드될 때마다 페이지 맨 위로 스크롤
   */
  return useEffect(() => {
    if (scroll) {
      window.scrollTo(0, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
};

export default useScrollTop;
